import React from "react";
import { Typography, Grid, Paper, Button } from "@mui/material";

const ThemeSample = () => {
    return (
        <div>
            <Grid container>
                <Grid item xs="auto" sx={{ margin: "10px" }}>
                    <Paper
                        elevation={5}
                        sx={{
                            padding: "20px",
                        }}
                    >
                        <Typography variant="h6">
                            Typography (variant)
                        </Typography>
                        <Typography variant="h1">h1</Typography>
                        <Typography variant="h2">h2</Typography>
                        <Typography variant="h3">h3</Typography>
                        <Typography variant="h4">h4</Typography>
                        <Typography variant="h5">h5</Typography>
                        <Typography variant="h5">h5</Typography>
                        <Typography variant="h6">h6</Typography>
                        <Typography variant="subtitle1">subtitle1</Typography>
                        <Typography variant="subtitle2">subtitle2</Typography>
                        <Typography variant="body1">body1</Typography>
                        <Typography variant="body2">body2</Typography>
                        <Typography variant="button">button</Typography>
                        <br />
                        <Typography variant="caption">caption</Typography>
                        <br />
                        <Typography variant="overline">overline</Typography>
                        <br />
                    </Paper>
                </Grid>
                <Grid item xs="auto" sx={{ margin: "10px" }}>
                    <Paper
                        elevation={5}
                        sx={{
                            padding: "20px",
                        }}
                    >
                        <Typography variant="h6">Buttons (variant)</Typography>
                        <Button variant="contained">contained</Button>
                        <br />
                        <Button variant="outlined">outlined</Button>
                        <br />
                        <Button variant="text">text</Button>
                    </Paper>
                </Grid>
                <Grid item xs="auto" sx={{ margin: "10px" }}>
                    <Paper
                        elevation={5}
                        sx={{
                            padding: "20px",
                        }}
                    >
                        <Typography variant="h6">Color</Typography>
                        <Button color="primary" variant="contained">
                            primary
                        </Button>
                        <Button color="secondary" variant="contained">
                            secondary
                        </Button>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    );
};

export default ThemeSample;
